export const sort = localStorage.getItem('smpSort') || 'sponsorMediaValue';
export const order = localStorage.getItem('smpOrder') || 'desc';
export const insightsGroupBy = JSON.parse(
    localStorage.getItem('storedGroupBy'),
) || ['rightsholderPlacement'];
